import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import FirstPartyDataLoader from '../../../../core/components/firstPartyData/loaders/FirstPartyDataLoader';
import FirstPartyDataMainController from '../../../../core/components/firstPartyData/controllers/FirstPartyDataMainController';
import FirstPartyDataDetailController from '../../../../core/components/firstPartyData/controllers/FirstPartyDataDetailController';
import FirstPartyDataMainView from '../main/FirstPartyDataMainView';
import FirstPartyDataDetailView from '../main/FirstPartyDataDetailView';

const FirstPartyDataRoutes = (props) => {
  const { path } = props.match;

  return (
    <Switch>
      <Route
        path={`${path}/main/:pageNumber?`}
        exact
        render={() => (
          <FirstPartyDataLoader {...props}>
            <FirstPartyDataMainController>
              <FirstPartyDataMainView />
            </FirstPartyDataMainController>
          </FirstPartyDataLoader>
        )}
      />
      <Route
        path={`${path}/details/:id`}
        exact
        render={() => (
          <FirstPartyDataLoader {...props}>
            <FirstPartyDataDetailController>
              <FirstPartyDataDetailView />
            </FirstPartyDataDetailController>
          </FirstPartyDataLoader>
        )}
      />
      {/* Fallback */}
      <Route path={`${path}`} render={() => <Redirect to={`${path}/main/1`} />} />
    </Switch>
  );
};

export default FirstPartyDataRoutes;
